// packages/chordpro/src/layout.js
//
// Строка с inline-аккордами → единицы «аккорд + слог», сгруппированные в СЛОВА.
// Группировка в слова — не украшение: слово не должно разрываться переносом,
// иначе слог уезжает на другую строку без своего аккорда.
//
// Возвращает массив слов; слово — массив единиц {ch, tx, notext}. Пробел между
// словами едет отдельным словом: именно там перенос и разрешён.

/**
 * @param {string} line
 * @returns {Array<Array<{ch:string|null, tx:string, notext?:boolean}>>}
 */
export function lineToWords(line) {
  const src = String(line ?? '');
  if (!src) return [];

  // 1. Разрезать на куски «скобка» / «текст».
  const parts = [];
  const re = /\[([^\]]*)\]/g;
  let last = 0;
  let m;
  while ((m = re.exec(src)) !== null) {
    if (m.index > last) parts.push({ ch: null, tx: src.slice(last, m.index) });
    parts.push({ ch: m[1], tx: '' });
    last = m.index + m[0].length;
  }
  if (last < src.length) parts.push({ ch: null, tx: src.slice(last) });

  // 2. Приклеить текст к аккорду, который стоит перед ним.
  const units = [];
  for (const p of parts) {
    if (p.ch !== null) { units.push({ ch: p.ch, tx: '' }); continue; }
    const prev = units[units.length - 1];
    // Текст, начинающийся с ПРОБЕЛА, к аккорду не приклеивается. Иначе аккорд
    // получает единицу с пробельным текстом, шаг 3 уводит её в ветку разрыва
    // и теряет `ch` — аккорд исчезает совсем. Замерено на as-is версии: из
    // десяти обычных строк аккорды терялись на пяти, включая «[C] aaa bbb»
    // (аккорд звучит до первого слога — самая частая форма) и «[Am]  [F]  [C]».
    // В терминах ChordPro это ровно то, что надо: аккорд без слога под ним.
    if (prev && prev.tx === '' && prev.ch !== null && !/^\s/.test(p.tx)) prev.tx = p.tx;
    else units.push({ ch: null, tx: p.tx });
  }

  // 3. Собрать единицы в слова, разрывая только по пробелам.
  const words = [];
  let w = [];
  const flush = () => { if (w.length) { words.push(w); w = []; } };

  for (const u of units) {
    if (u.tx === '') { w.push({ ch: u.ch, tx: '', notext: true }); continue; }
    const pieces = u.tx.split(/(\s+)/);
    let first = true;
    for (const pc of pieces) {
      if (pc === '') continue;
      if (/^\s+$/.test(pc)) { flush(); words.push([{ ch: null, tx: pc }]); first = false; continue; }
      if (first) { w.push({ ch: u.ch, tx: pc }); first = false; }
      else { flush(); w.push({ ch: null, tx: pc }); }
    }
  }
  flush();
  return words;
}
